export default [
  {
    path: '/',
    name: 'Registration',
    component: () => import('@/views/Registration.vue'),
  },
  {
    path: '/introduce',
    name: 'Introduce',
    component: () => import('@/views/Introduce.vue'),
  },
  {
    path: '/instruction',
    name: 'Instruction',
    component: () => import('@/views/Instruction.vue'),
  },
  {
    path: '/exercise/:id',
    name: 'Exercise',
    component: () => import('@/views/Exercise.vue'),
  },
  {
    path: '/done',
    name: 'Done',
    component: () => import('@/views/Done.vue'),
  },
  {
    path: '/upload',
    name: 'Upload',
    component: () => import('@/views/Upload.vue'),
  },
];
